<template>
    <div class="main-wrapper background--b2c">
      <div class="grid">
        <div class="header header--subpage">
            <button style="border-radius: 0; border: none; background-color: transparent;" @click="$emit('home')"><img src="/assets/icons/mimi-logo.svg"></button>
            <button class="btn--back" @click="$emit('back')">Back</button>
        </div>
          <div class="content-wrapper--subpage">
            <div class="content--subpage">
                <div>
                    <h1>Try Mimi for yourself</h1>
                    <p>Experience Sound personalization with one <br>of our Mimi partners.</p>
                </div>
                <div>
                    <img class="mimi-enabled-devices" src="/assets/images/ifa-2022-mimi-partner-devices.png">
                    <p class="caption">Scan or visit info.mimi.io/ifa-2022-mimi-partner-devices</p>
                </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'B2C'
  }

</script>

<style>

.background--b2c {
 background-image: url("/assets/images/background--b2c.jpg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.content-wrapper--subpage {
  padding: 2rem 0 2rem 2rem;
  color: #333;
  height: 100%;
  font-style: normal;
  font-family: Arial, Helvetica, sans-serif;
  font-style: normal;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}

.content--subpage h1 {
  font-size: 2.25rem;
  font-weight: 400;
  margin-bottom: 0.5rem;
}

.content--subpage p {
  font-size: 1rem;
  line-height: 1.5rem;
  margin: 0 auto 2rem auto;
}

.content--subpage .caption {
    font-size: 0.75rem;
    font-weight: 600;
}

img.mimi-enabled-devices {
  width: 16rem;
  height: 16rem;
  }

</style>